if (!customElements.get("quick-shop")) {
  class QuickShop extends HTMLElement {
    constructor() {
      super();
      // Bind option select events
      this.querySelectorAll("[data-quick-shop-option]").forEach((option) =>
        option.addEventListener(
          "click",
          this.onOptionSelect.bind(
            this,
            option.value,
            option.dataset.inventoryQuantity
          )
        )
      );
    }

    /**
     * Adds a variant to the cart
     * @description Adds the clicked option/variant to the cart leveraging the product form component.
     * @param {String} variantId
     * @param {String} inventoryQuantity
     */
    onOptionSelect(variantId, inventoryQuantity) {
      const productForm = this.querySelector("product-form");
      const hiddenInputId = productForm.querySelector('input[name="id"]');
      const hiddenInventoryQty = productForm.querySelector(
        'input[name="inventory_quantity"]'
      );
      const submitButton = productForm.querySelector('[type="submit"]');

      hiddenInputId.value = variantId;
      hiddenInventoryQty.value = inventoryQuantity;
      submitButton.click();
    }
  }

  window.QuickShop = QuickShop;
  customElements.define("quick-shop", QuickShop);
}
